// @ts-expect-error
window.setLocationHref = (path) => {
  window.location.href = path
}
